import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=0411f436"
import script from "./PopupLayout.vue?vue&type=script&lang=js"
export * from "./PopupLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports